import { epicRequest, serverResponse } from 'app'
import storage from 'global-utils/Storage'

import store from '../../../../config/store'

export const TOURNAMENT_FETCH = 'TOURNAMENT_FETCH'
export const TOURNAMENT_FETCH_ERROR = 'TOURNAMENT_FETCH_ERROR'
export const TOURNAMENT_FETCH_FULFILLED = 'TOURNAMENT_FETCH_FULFILLED'
export const TOURNAMENT_FETCH_CANCELED = 'TOURNAMENT_FETCH_CANCELED'

export const TOURNAMENT_PLAYERS_STATS_FETCH = 'TOURNAMENT_PLAYERS_STATS_FETCH'
export const TOURNAMENT_PLAYERS_STATS_FETCH_ERROR = 'TOURNAMENT_PLAYERS_STATS_FETCH_ERROR'
export const TOURNAMENT_PLAYERS_STATS_FETCH_FULFILLED = 'TOURNAMENT_PLAYERS_STATS_FETCH_FULFILLED'
export const TOURNAMENT_PLAYERS_STATS_FETCH_CANCELED = 'TOURNAMENT_PLAYERS_STATS_FETCH_CANCELED'

export const TOURNAMENT_RANGE_MATCHES_FETCH = 'TOURNAMENT_RANGE_MATCHES_FETCH'
export const TOURNAMENT_RANGE_MATCHES_FETCH_CANCELED = 'TOURNAMENT_RANGE_MATCHES_FETCH_CANCELED'
export const TOURNAMENT_RANGE_MATCHES_FETCH_ERROR = 'TOURNAMENT_RANGE_MATCHES_FETCH_ERROR'
export const TOURNAMENT_RANGE_MATCHES_FETCH_FULFILLED = 'TOURNAMENT_RANGE_MATCHES_FETCH_FULFILLED'

export const TOURNAMENT_LAST_VIEWED = 'TOURNAMENT_LAST_VIEWED'

export const getInitialState = () =>
  serverResponse({
    lastViewed: storage.get('swv.last.tournament'),
    matches: serverResponse(),
    playersStats: serverResponse(),
  })

export const tournamentLastViewed = (id) => {
  storage.save('swv.last.tournament', id)
  return {
    payload: id,
    type: TOURNAMENT_LAST_VIEWED,
  }
}

// Re-fetch every 10 minutes
const tournamentFetchInterval = 10 * 60 * 1000
let tournamentFetchTimeout = null
export const tournamentFetch = (payload) => ({
  payload,
  type: TOURNAMENT_FETCH,
})

export const tournamentFetchFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_FETCH_FULFILLED,
})

export const tournamentFetchCanceled = () => {
  clearTimeout(tournamentFetchTimeout)
  return {
    payload: null,
    type: TOURNAMENT_FETCH_CANCELED,
  }
}

export const tournamentFetchError = (payload) => {
  clearTimeout(tournamentFetchTimeout)
  return {
    payload,
    type: TOURNAMENT_FETCH_ERROR,
  }
}

export const tournamentPlayersStatsFetch = (id) => ({
  payload: id,
  type: TOURNAMENT_PLAYERS_STATS_FETCH,
})

export const tournamentPlayersStatsFetchFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_PLAYERS_STATS_FETCH_FULFILLED,
})

export const tournamentPlayersStatsFetchCanceled = () => ({
  payload: null,
  type: TOURNAMENT_PLAYERS_STATS_FETCH_CANCELED,
})

export const tournamentPlayersStatsFetchError = (payload) => ({
  payload,
  type: TOURNAMENT_PLAYERS_STATS_FETCH_ERROR,
})

export const tournamentFetchEpic = epicRequest({
  actionType: TOURNAMENT_FETCH,
  errorAction: tournamentFetchError,
  fulfilledAction: tournamentFetchFulfilled,
  maps: [
    (response, action) => {
      clearTimeout(tournamentFetchTimeout)
      tournamentFetchTimeout = setTimeout(() => {
        store.dispatch(tournamentFetch(action.payload))
      }, tournamentFetchInterval)
    },
  ],
  request: ({ payload }) => `sports/tournament/${payload}`,
  untilTypes: TOURNAMENT_FETCH_CANCELED,
})

export const tournamentPlayersStatsFetchEpic = epicRequest({
  actionType: TOURNAMENT_PLAYERS_STATS_FETCH,
  errorAction: tournamentPlayersStatsFetchError,
  fulfilledAction: tournamentPlayersStatsFetchFulfilled,
  request: ({ payload }) => `sports/soccer/tournament/${payload}/players/stats`,
  untilTypes: TOURNAMENT_PLAYERS_STATS_FETCH_CANCELED,
})

export const tournamentRangeMatchesFetch = (tournamentId, start, end, tz) => ({
  payload: {
    end,
    start,
    tournamentId,
    tz,
  },
  type: TOURNAMENT_RANGE_MATCHES_FETCH,
})

export const tournamentRangeMatchesFetchFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_RANGE_MATCHES_FETCH_FULFILLED,
})

export const tournamentRangeMatchesFetchCanceled = () => ({
  payload: null,
  type: TOURNAMENT_RANGE_MATCHES_FETCH_CANCELED,
})

export const tournamentRangeMatchesFetchError = (payload) => ({
  payload,
  type: TOURNAMENT_RANGE_MATCHES_FETCH_ERROR,
})

export const tournamentRangeMatchesFetchEpic = epicRequest({
  actionType: TOURNAMENT_RANGE_MATCHES_FETCH,
  errorAction: tournamentRangeMatchesFetchError,
  fulfilledAction: tournamentRangeMatchesFetchFulfilled,
  request: ({ payload }) =>
    `sports/soccer/tournament/${payload.tournamentId}/matches?from=${payload.start}&to=${payload.end}&tz=${payload.tz}`,
  untilTypes: TOURNAMENT_RANGE_MATCHES_FETCH_CANCELED,
})
